import { Link, useMatch, useResolvedPath } from "react-router-dom"
import { useState, useEffect } from "react"
import Auth from "./Auth"

export default function Navbar() {
  const [showAuth, setShowAuth] = useState(false);
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      setUser(JSON.parse(currentUser));
    }
  }, []);

const handleLogin = (userData) => {
    setUser(userData);
    // Forzar recarga del estado en otros componentes
    window.dispatchEvent(new Event('storage'));
};

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    setUser(null);
    setMenuOpen(false);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <nav className="nav">
        <h1 className="site-title green-text">Custom radar chart</h1>
        
        {/* Burger button - Solo móvil */}
        <button 
          className={`burger-menu ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Menu - Desktop siempre visible, Mobile con overlay */}
        <div className={`nav-right ${menuOpen ? 'mobile-open' : ''}`}>
          <ul className="green-text">
            <CustomLink to="/" onClick={closeMenu}>Home</CustomLink>
            <li>
              <a href="/tutorial.html" onClick={(e) => {
                e.preventDefault();
                window.location.href = '/tutorial.html';
                closeMenu();
              }}>
                Tutorial
              </a>
            </li>
            <li>
              <a href="/examples.html" onClick={(e) => {
                e.preventDefault();
                window.location.href = '/examples.html';
                closeMenu();
              }}>
                Examples
              </a>
            </li>
            <li>
              <a href="/blog/data-visualization-guide.html" onClick={(e) => {
                e.preventDefault();
                window.location.href = '/blog/data-visualization-guide.html';
                closeMenu();
              }}>
                Blog
              </a>
            </li>
          </ul>
          
          {user ? (
            <div className="user-menu">
              <span className="username">{user.username}</span>
              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          ) : (
            <button className="login-btn" onClick={() => {
              setShowAuth(true);
              closeMenu();
            }}>
              Login
            </button>
          )}
        </div>
      </nav>

      {showAuth && (
        <Auth 
          onClose={() => setShowAuth(false)} 
          onLogin={handleLogin}
        />
      )}
    </>
  )
}

function CustomLink({ to, children, onClick, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end: true })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} onClick={onClick} {...props}>
        {children}
      </Link>
    </li>
  )
}